<script lang="ts" setup>
import type { IProps } from './TextWithIconBoxes.types'

defineProps<IProps>()
</script>

<template>
  <UiSection :color="color">
    <div
      :class="[
        'text-with-icon-boxes',
        `text-with-icon-boxes--${layout}`
      ]"
    >
      <UiHeader
        :header="header"
        position="center"
      />

      <div
        v-if="text"
        class="text-with-icon-boxes__text"
        v-html="text"
      />

      <div class="text-with-icon-boxes__content">
        <div class="text-with-icon-boxes__boxes">
          <UiListWithIcons
            v-if="list.length"
            :list="list"
            :layout="layout ? layout : ''"
          />
        </div>

        <div
          v-if="textSecond"
          class="text-with-icon-boxes__text--second"
          v-html="textSecond"
        />

        <UiButton
          v-if="button"
          :to="button.to"
        >
          {{ button.text }}
        </UiButton>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
.section {
  padding-bottom: 2.4rem;
}

.text-with-icon-boxes {
  $root: &;

  :deep() {
    .ui-header {
      max-width: 87rem;
      margin: 0 auto;
    }
  }

  &__text {
    margin-top: 2.4rem;
    font-weight: 500;
    font-size: 2rem;
    line-height: 2.8rem;
    text-align: center;

    @include atM {
      max-width: 87rem;
      margin: 0 auto;
      margin-top: 4rem;
      font-size: 2.4rem;
      line-height: 3.2rem;
    }

    &--second {
      margin-bottom: 3.2rem;
      font-weight: 500;
      font-size: 1.6rem;
      line-height: 2.4rem;
      text-align: center;

      @include atM {
        max-width: 87rem;
        margin: 0 auto;
        margin-bottom: 5.6rem;
        font-size: 1.8rem;
      }
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    margin-top: 4.4rem;
    padding: 0 1.6rem 4rem 1.6rem;
    background-color: $white;
    border-radius: 1.6rem;

      @include atM {
        margin-top: 9.4rem;
        padding: 0 1.6rem 8.8rem 1.6rem;
      }

    .button {
      align-self: center;
    }
  }

  &__boxes {
    max-width: 115.2rem;
    width: 100%;
    margin: 0 auto;

    @include atXL {
      max-width: 134rem;
    }
  }

  &--layout-2 {
    
    :deep() {
      .ui-header {
        max-width: 118rem;
        margin: 0 auto;
      }
    }

    #{$root}__content {
      padding: 0;

      @include atM {
        margin-top: 4.8rem;
      }
    }

    #{$root}__boxes {
      max-width: 160rem;
    }
  }

  &--layout-3 {
    #{$root}__content {
      padding: 0;
      background-color: transparent;
    }
  }
}
</style>
